import { useKeycloak } from '@react-keycloak/web';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FragnetService, { Calc } from 'services/FragnetService';

export const useCalculations = () => {
  const { t } = useTranslation();
  const [calculations, setCalculations] = useState<Calc[]>([]);
  const { keycloak } = useKeycloak();
  const errorMessage = t('calcs_fetch_err'); // defined outside for exhaustive react hooks

  keycloak.token && FragnetService.setToken(keycloak.token);

  useEffect(() => {
    const response = FragnetService.getCalculations();

    if (response !== undefined) {
      response
        .then((calcs) => setCalculations(calcs))
        .catch((error: AxiosError) => {
          console.log(errorMessage);
          console.error(error);
        });
    } else {
      setCalculations([]);
    }
  }, [errorMessage]);

  return calculations;
};

export default useCalculations;
